import React from "react";

export default function Footer() {
    return (
      <footer>
        This project was coded by{" "}
        <a
          href="https://www.behance.net/fotinia_sadovskaya"
          target="_blank"
          rel="noopener noreferrer"
        >
          Svitlana Voronko
        </a>{" "}
        {/* and is{" "}
        <a
          href="https://github.com/fotinia-sadovskaya/react-weather-app"
          target="_blank"
          rel="noopener noreferrer"
        >
          open-sourced on GitHub
        </a>{" "}
        and{" "}
        <a
          href="https://papaya-frangollo-58717c.netlify.app/"
          target="_blank"
          rel="noopener noreferrer"
        >
          hosted on Netlify
        </a> */}
      </footer>
    );
}
